// ErrorDialog.js
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { PropTypes } from 'prop-types';

const ErrorDialog = ({ open, onErrorDialogClose, errorMessage }) => {
  return (
    <Dialog open={open} onErrorDialogClose={onErrorDialogClose}>
      <DialogTitle>Error</DialogTitle>
      <DialogContent>{errorMessage}</DialogContent>
      <DialogActions>
        <Button onClick={onErrorDialogClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ErrorDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onErrorDialogClose: PropTypes.func.isRequired,
  errorMessage: PropTypes.string.isRequired
};

export default ErrorDialog;
